const stringToId = (value)=>value.trim().toLowerCase().replace(/(\s)/g, '-');
export { stringToId };
